export function loadTemplatesPlugin() {
  FroalaEditor.POPUP_TEMPLATES["templates.popup"] = '[_CUSTOM_LAYER_]';

  FroalaEditor.PLUGINS.templates = function (editor) {
    return {
      showPopup: function () {
        this.buildPopup();
        editor.popups.setContainer('templates.popup', editor.$tb);
        var $btn = editor.$tb.find('.fr-command[data-cmd="templates"]');
        var left = $btn.offset().left + $btn.outerWidth() / 2;
        var top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
        editor.popups.show('templates.popup', left, top, $btn.outerHeight());
      },

      buildPopup: function () {
        const templates = getDefaults();
        let html = '<div class="fr-templates-popup">';
        for (const tpl of templates) {
          html += `
            <div class="fr-template-item" data-id='${tpl.id}'>
              ${tpl.image ? `<img src="${tpl.image}" style="max-width:100px;" />` : ''}
              <div class="fr-template-item-description">
                <strong>${tpl.title}</strong><br/>
                <small>${tpl.description}</small>
              </div>
            </div>`;
        }
        html += '</div>';

        const $popup = editor.popups.create('templates.popup', {
          custom_layer: html
        });

        // Bind click events
        $popup.on('click', '.fr-template-item', function () {
          const html = templates.find(t => t.id.toString() === this.dataset.id).html;
          editor.html.insert(html, false);
          editor.popups.hide('templates.popup');
        });

        return $popup;
      }
    };
  };

  FroalaEditor.DefineIcon('templates', {
    SRC: '/assets/images/froala-plugins/templates/templates.icon.svg',
    ALT: 'Templates',
    template: 'image'
  });

  FroalaEditor.RegisterCommand('templates', {
    title: 'Insert Template',
    icon: 'templates',
    undo: true,
    focus: true,
    plugin: 'templates',
    callback: function () {
      this.templates.showPopup();
    }
  });

  FroalaEditor.RegisterQuickInsertButton('templates', {
    title: 'Insert Template',
    icon: 'templates',
    undo: true,
    focus: true,
    plugin: 'templates',
    callback: function () {
      this.templates.showPopup();
    }
  });

  FroalaEditor.LANGUAGE['de'] = FroalaEditor.LANGUAGE['de'] || {};

  // Extend it with your plugin's translations
  Object.assign(FroalaEditor.LANGUAGE['de'].translation, {
    'Insert Template': 'Vorlage einfügen',
  });

  const getDefaults = () => {
    const paragraphClass = 'template-text-element';
    const en = {
      fullTitle: 'Full',
      fullDesc: 'A template that defines a full text area.',
      halfsTitle: 'Two halfs',
      halfsDesc: 'A template that defines two equal text areas.',
      thirdsTitle: 'Three thirds',
      thirdsDesc: 'A template that defines three equal text areas.',
      halfRightImgTitle: 'One half with right side image',
      halfRightImgDesc: 'A template that defines a text area and an image on its right side.',
      halfLeftImgTitle: 'One half with left side image',
      halfLeftImgDesc: 'A template that defines a text area and an image on its left side.',
      twoHalfImgTitle: 'Two halves with an image each',
      twoHalfImgDesc: 'A template that defines two equal image areas.',
      thirdLeftImgTitle: 'Large text area with left side image',
      thirdLeftImgDesc: 'A template that defines a large text area and an image on its left side.',
      thirdRightImgTitle: 'Large text area with right side image',
      thirdRightImgDesc: 'A template that defines a large text area and an image on its right side.',
    };

    const de = {
      fullTitle: 'Voll',
      fullDesc: 'Eine Vorlage, die einen Volltextbereich definiert.',
      halfsTitle: 'Zwei Hälften',
      halfsDesc: 'Eine Vorlage, die zwei gleiche Textbereiche definiert.',
      thirdsTitle: 'Drei Drittel',
      thirdsDesc: 'Eine Vorlage, die drei gleiche Textbereiche definiert.',
      halfRightImgTitle: 'Eine Hälfte mit Bild auf der rechten Seite',
      halfRightImgDesc: 'Eine Vorlage, die einen Textbereich und ein Bild auf der rechten Seite definiert.',
      halfLeftImgTitle: 'Eine Hälfte mit Bild auf der linken Seite',
      halfLeftImgDesc: 'Eine Vorlage, die einen Textbereich und ein Bild auf der linken Seite definiert.',
      twoHalfImgTitle: 'Zwei Hälften mit je einem Bild',
      twoHalfImgDesc: 'Eine Vorlage, die zwei gleiche Bildbereiche definiert.',
      thirdLeftImgTitle: 'Großer Textbereich mit Bild auf der linken Seite',
      thirdLeftImgDesc: 'Eine Vorlage, die einen großen Textbereich und ein Bild auf der linken Seite definiert.',
      thirdRightImgTitle: 'Großer Textbereich mit Bild auf der rechte Seite',
      thirdRightImgDesc: 'Eine Vorlage, die einen großen Textbereich und ein Bild auf der rechte Seite definiert.',
    };

    const tsLang = H5PEditor.contentLanguage === 'de' ? de : en;
    const textElement = `<div class="${paragraphClass}" contentEditable=true></div>`

    return [{
      id: 1,
      title: tsLang.fullTitle,
      image: '/assets/images/froala-plugins/templates/full.png',
      description: tsLang.fullDesc,
      html: `<div class="h5p-wysiwyg-custom-template" style='display: flex; padding: 10px; background: #f9f9f9 !important; margin: 0 0 15px;'>${textElement}</div>`
    },
    {
      id: 2,
      title: tsLang.halfsTitle,
      image: '/assets/images/froala-plugins/templates/two_halfs.png',
      description: tsLang.halfsDesc,
      html: `<div class="h5p-wysiwyg-custom-template" style='display: flex; padding: 15px 0;'>
        <div class="h5p-wysiwyg-custom-template-item" style='min-height: 42px; flex: 1; padding: 10px; height: 0%; margin-right: 7px; background: #f9f9f9 !important'">${textElement}</div>
        <div class="h5p-wysiwyg-custom-template-item" style='min-height: 42px; flex: 1; padding: 10px; height: 0%; margin-left: 7px; background: #f9f9f9 !important'">${textElement}</div>
      </div>`
    },
    {
      id: 3,
      title: tsLang.thirdsTitle,
      image: '/assets/images/froala-plugins/templates/three_thirds.png',
      description: tsLang.thirdsDesc,
      html: `<div class="h5p-wysiwyg-custom-template" style='display: flex; padding: 15px 0;'>
        <div class="h5p-wysiwyg-custom-template-item" style='min-height: 42px; flex: 1; padding: 10px; height: 0%; margin-right: 10px; background: #f9f9f9 !important'">${textElement}</div>
        <div class="h5p-wysiwyg-custom-template-item" style='min-height: 42px; flex: 1; padding: 10px; height: 0%; margin-left: 5px; margin-right: 5px; background: #f9f9f9 !important'">${textElement}</div>
        <div class="h5p-wysiwyg-custom-template-item" style='min-height: 42px; flex: 1; padding: 10px; height: 0%; margin-left: 10px; background: #f9f9f9 !important'">${textElement}</div>
      </div>`
    },
    {
      id: 4,
      title: tsLang.halfRightImgTitle,
      image: '/assets/images/froala-plugins/templates/one_half_with_image_right.png',
      description: tsLang.halfRightImgDesc,
      html: `<div class="h5p-wysiwyg-custom-template" style='display: flex; padding: 15px 0;'>
        <div class="h5p-wysiwyg-custom-template-item" style='min-height: 42px; flex-basis: 50%; padding: 10px; height: 0%; background: #f9f9f9 !important; box-sizing: border-box; margin-right: 7px;'>${textElement}</div>
        <span style="margin-left: 7px;flex-basis:50%;box-sizing: border-box;"><img src='' alt=''  style='flex: 1; width: 100%; height: auto; min-height: 40px;' /></span>
      </div>`,
    },
    {
      id: 5,
      title: tsLang.halfLeftImgTitle,
      image: '/assets/images/froala-plugins/templates/one_half_with_image_left.png',
      description: tsLang.halfLeftImgDesc,
      html: `<div class="h5p-wysiwyg-custom-template" style='display: flex; padding: 15px 0;'>
        <span style="margin-right: 7px; flex-basis:50%; box-sizing: border-box;"><img src='' alt=''  style='flex: 1; width: 100%; height: auto; min-height: 40px;' /></span>
        <div class="h5p-wysiwyg-custom-template-item" style='min-height: 42px; flex-basis: 50%; padding: 10px; height: 0%; background: #f9f9f9 !important; box-sizing: border-box; margin-left: 7px;'>${textElement}</div>
      </div>`,
    },
    {
      id: 6,
      title: tsLang.twoHalfImgTitle,
      image: '/assets/images/froala-plugins/templates/two_halves_images.png',
      description: tsLang.twoHalfImgDesc,
      html: `<div class="h5p-wysiwyg-custom-template" style='display: flex; padding: 15px 0;'>
        <span style="margin-right: 7px; flex-basis:50%; box-sizing: border-box;"><img src='' alt=''  style='flex: 1; width: 100%; height: auto; min-height: 40px;' /></span>
        <span style="margin-right: 7px; flex-basis:50%; box-sizing: border-box;"><img src='' alt=''  style='flex: 1; width: 100%; height: auto; min-height: 40px;' /></span>
      </div>`,
    },
    {
      id: 7,
      title: tsLang.thirdLeftImgTitle,
      image: '/assets/images/froala-plugins/templates/one_third_with_image.png',
      description: tsLang.thirdLeftImgDesc,
      html: `<div class="h5p-wysiwyg-custom-template" style='display: flex; padding: 15px 0; margin-bottom: 15px;'>
        <span style="margin-right: 7px;flex-basis:33%;box-sizing: border-box;"><img src='' alt=''  style='flex: 1; width: 100%; height: auto; min-height: 40px;' /></span>
        <div class="h5p-wysiwyg-custom-template-item" style='min-height: 42px; flex-basis: 67%; padding: 10px; height: 0%; background: #f9f9f9 !important; box-sizing: border-box; margin-left: 7px;'>${textElement}</div>
      </div>`,
    },
    {
      id: 8,
      title: tsLang.thirdRightImgTitle,
      image: '/assets/images/froala-plugins/templates/one_third_with_image_right.png',
      description: tsLang.thirdRightImgDesc,
      html: `<div class="h5p-wysiwyg-custom-template" style='display: flex; padding: 15px 0; margin-bottom: 15px;'>
        <div class="h5p-wysiwyg-custom-template-item" style='min-height: 42px; flex-basis: 67%; padding: 10px; height: 0%; background: #f9f9f9 !important; box-sizing: border-box; margin-right: 7px;'>${textElement}</div>
        <span style="margin-left: 7px;flex-basis:33%;box-sizing: border-box;"><img src='' alt=''  style='flex: 1; width: 100%; height: auto; min-height: 40px;' /></span>
      </div>`,
    }]
  }
}
